import React from "react";
import { Link } from "gatsby";

import styled from "styled-components";
import { shuffleArray } from "../utils/utils";
import { media } from "./_includes/Device";
import { EVENT_TYPE, JOB_TYPE } from "../utils/utils";

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 45px 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  display: none;

  h3,
  .content,
  li,
  a {
    color: #333;
  }

  h1,
  h2,
  h3,
  h4 {
    margin-top: 40px;
  }

  ${media.tablet`
    padding: 35px 0;
    display: block;
    
    .content {
      padding: 0;
    }
  `};
`;

const SideBar = styled.div`
  background: white;
  border-radius: 15px;
  width: 380px;
  flex-shrink: 0;
  position: relative;
  z-index: 1;

  .content,
  li,
  a {
    color: #999;
  }

  ${media.tablet`
    transform: translate(0);
    width: 100%;
    padding: 40px 20px;
  `};
`;

const RelatedItem = styled(Link)`
  display: block;
  padding: 40px 0;
  border-bottom: 1px solid #e5e5e5;
  cursor: pointer;

  &:hover,
  &:focus {
    h3 {
      color: #e1171e;
    }
  }

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  h3 {
    margin: 0;
    color: #333;
    transition: color 0.3s ease-in-out;
  }

  ${media.tablet`
    padding: 20px 0;
    
    &:hover,
    &:focus {
      h3 {
        color: #333;
      }
    }
  `};
`;

const RelatedTitle = styled.p`
  color: #999;
  margin: 0;
`;

export class RelatedJobs extends React.Component {
  constructor(props) {
    super(props);

    let relatedItems = this.props.related;
    this.relatedCollection = [];

    if (relatedItems.board_type === EVENT_TYPE) {
      this.relatedPrefix = EVENT_TYPE;
    } else {
      this.relatedPrefix = JOB_TYPE;

      this.relatedCollection = shuffleArray(
        relatedItems.departments[0].jobs.filter(
          job => job.id !== relatedItems.id
        )
      ).slice(0, 4);
    }
  }

  render() {
    // take out current event from related events, mix the array and get the first 4
    return (
      <Container>
        {this.relatedCollection.length > 0 && (
          <SideBar>
            <RelatedTitle>Related content</RelatedTitle>

            {this.relatedCollection &&
              this.relatedCollection.map(relatedItem => {
                return (
                  <RelatedItem
                    to={`/${this.relatedPrefix}/${relatedItem.slug}-${
                      relatedItem.gh_Id
                    }`}
                    key={relatedItem.id}
                  >
                    <h3>{relatedItem.title}</h3>
                  </RelatedItem>
                );
              })}
          </SideBar>
        )}
      </Container>
    );
  }
}
